import React, { FC, useEffect, useState } from 'react'
import s from './QuizNotification.module.scss'
import { useTranslation } from '@hooks/useTranslation'
import { Button } from '@components/UIKit/Button/Button'
import Image from 'next/image'

interface Props {
    onClick: () => void
}

export const QuizNotification: FC<Props> = ({ onClick }) => {
    const { translate: tr } = useTranslation()

    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768)
        }

        checkMobile()
        window.addEventListener('resize', checkMobile)
        return () => window.removeEventListener('resize', checkMobile)
    }, [])

    return (
        <div className={s.container}>
            <Image
                className={s.container__header}
                src={isMobile ? '/assets/images/quiz/rate-app-mob.png' : '/assets/images/quiz/rate-app.png'}
                alt='Rate the app'
                width={isMobile ? 272 : 336}
                height={isMobile ? 52 : 68}
                objectFit='contain'
                priority={true}
                loading='eager'
            />
            <p className={s.container__text}>{tr({ id: 'quiz.message' })}</p>
            <Button
                className={s.container__btn}
                id='default_button'
                size={'large'}
                color={'Black'}
                onClick={onClick}>
                {tr({ id: 'quiz.go' })}
            </Button>
        </div>
    )
}
